import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Books from "@/assets/project-assets/books.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Speciality from "@/assets/speciality-services.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";
import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
import Luggage from "@/assets/project-assets/luggage.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import Desserts from "@/assets/confectionary.svg";
import Parking from "@/assets/project-assets/parking.svg";
import HomeTech from "@/assets/home&tech.svg";
import Tailors from "@/assets/project-assets/tailors&textiles.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import PhoneCharging from "@/assets/key.svg";
import GiftCard from "@/assets/gift_cards.svg";
import ElectricWheelchairs from "@/assets/electric-wheelchairs-light.svg";
import ExpectantParking from "@/assets/project-assets/Expectant-mother-parking.svg";
import FamilyParking from "@/assets/family-parking.svg";
import LowEmissionParking from "@/assets/project-assets/Low-emission-parking.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:1988dda9-e29c-414a-8e9b-84f89a2bedfb",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: Books,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:947dec04-efed-4948-ac29-9ac94f4f5b8b",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:9cddc559-a12c-4932-980d-c22779533bb5",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:f5939f1f-70e4-4dea-83e2-2e1b5d65674e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:00ac67b3-9759-4251-a430-efbaa453e419",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:2de4ccd0-18be-4f21-8c0b-1525515e214a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:712ddd79-9184-4aaa-ab0f-5384b9cde502",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:aec42025-540b-4ad9-9e28-f501a6f69bdd",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:ee9f7b18-b157-4010-94f9-b287d51e7b3e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:fb0c9536-5cfc-4fe4-a1b9-acaad212985d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:25d38644-2631-468a-96ec-0bf0009bbbae",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luggage-leather",
        iconImage: Luggage,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:6b9df2b3-c97b-4f76-b824-44a4f2e3ea34",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:89e5a99f-a090-491f-b5b7-8c4a930f90f0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:e57b89fa-6e0c-4b53-83c1-628468b23fb9",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services",
        iconImage: Speciality,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:811a55d4-0aa4-4225-8e66-f3aa689c1fa0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:48baf3b3-36fd-4a1a-8801-d5fd29d5667c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "tailors-textiles",
        iconImage: Tailors,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:e5d8bd1b-d2e3-4a3f-9781-bd06611bc989",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:c7f1c1a3-92ae-46a5-8d4f-07c3a7502ead",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:dd28482d-a0ca-4667-be56-298a4ea9d2dd",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:e20816c5-e16e-4681-a50f-819d6bb306ae",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:1e5092bf-c3c3-4a42-92e2-2e701653cd53",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:7947a11d-64bf-4542-86c6-e27bc6e21b05",
        type: "list",
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:152457b1-cc5d-4925-bf29-e89d2f816ba7",
        type: "list",
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:04347cda-6b1b-4a50-9e5f-38a8a9126fe4",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:192fb02d-5717-4284-9d02-d0490b7a6e1a",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:2ab47071-8e19-4c4f-a3fd-4127f6c7f9df",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:04347cda-6b1b-4a50-9e5f-38a8a9126fe4",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:192fb02d-5717-4284-9d02-d0490b7a6e1a",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:04347cda-6b1b-4a50-9e5f-38a8a9126fe4",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:192fb02d-5717-4284-9d02-d0490b7a6e1a",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:1d3651c5-1f0d-45d8-a469-7d343def63e3",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "uber-carrem",
        iconImage: UberCareem,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:9068e72f-5116-4e15-9502-d7ee889d0d88",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:fdbc4e7a-6ba3-4f4f-82ec-c8463e6c3a09",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0c3e8cd5-174f-4b0e-bdfd-6474c5df1c9e",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:10c1625c-3566-40f7-951b-469ae5f0221e",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "expectant-mother-parking",
        iconImage: ExpectantParking,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:06ae6f99-3c11-4450-87ef-b261e683805d",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "electric-car-charging",
        iconImage: ElectricCarCharging,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:fe78e3e5-b2ba-4f6a-bf26-44e252dd8c67",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "low-emission-parking",
        iconImage: LowEmissionParking,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:6103aa02-6f5b-4034-abd6-40dda7f32048",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "park-assist",
        iconImage: ParkingAssist,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:d09dc7d2-f2c9-40a3-abe0-055599be601c",
        type: "list",
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
      },
      {
        title: "phone-charging",
        iconImage: PhoneCharging,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:dcaca54d-a0e7-4401-9a5a-d9f9955770c6",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "electric-wheelchairs",
        iconImage: ElectricWheelchairs,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:0b35d27a-c4de-4347-8a53-07bc03aeabb9",
        type: "closest",
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "51baa989-7941-4647-b5c4-54f12c03ea98:9f0b86b3-b11d-4820-8037-f7b42678e0a4",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "parking-bays",
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:f399c176-e030-4d78-a489-1085144b45ff",
          "51baa989-7941-4647-b5c4-54f12c03ea98:08bc4c46-41b4-4cd3-80ab-1e07f5f0350b",
          "51baa989-7941-4647-b5c4-54f12c03ea98:87ab59b6-f4fc-4fa7-aa8b-4d0c8d494f5c",
          "51baa989-7941-4647-b5c4-54f12c03ea98:486ef9e3-dcf5-4fcf-8763-1eadc176b051",
          "51baa989-7941-4647-b5c4-54f12c03ea98:32549f2a-d0e8-4456-b926-98a7c0e86638",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "vacant",
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:4aeb1a37-ebd7-4ba7-874f-e71a20fd970f",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "others",
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:d44a2f55-7605-42cb-bfb0-151cb4664f3d",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: [
          "51baa989-7941-4647-b5c4-54f12c03ea98:f284149d-38b1-4846-ae00-f5af9551e7c6",
        ],
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
